import React from 'react';
import PropTypes from 'prop-types';
import TextFilterInput from './TextFilterInput';
import WidgetsList from './WidgetsList';
import ButtonControlWrapper from './ButtonControlWrapper';
import CardText from 'material-ui/Card/CardText';

function Pack({ params }) {
    return (
        <CardText>
            <TextFilterInput />
            <WidgetsList packId={params.packId} />
            <ButtonControlWrapper />
        </CardText>
    );
}

Pack.propTypes = {
    params: PropTypes.object.isRequired
};

export default Pack;



/** WEBPACK FOOTER **
 ** ../src/dash/front/packs/components/Pack.js
 **/